import EvStationIcon from '@mui/icons-material/EvStation'
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation'
import { useTranslate } from 'ra-core'
import { useRecordContext, useReference } from 'react-admin'

import FieldRow from './FieldRow'
import CircularGaugeIcon from '../CircularGaugeIcon'
import UnitField from '../UnitField'
import { INFO_WINDOW_TRANSLATION_KEY } from './AdvancedInfoWindow'

const AutonomyField = () => {
  const translate = useTranslate()
  const telemetry = useRecordContext()
  const { referenceRecord: vehicle } = useReference({
    reference: 'vehicles',
    id: telemetry?.vehicle_id,
    options: { enabled: !!telemetry?.vehicle_id },
  })

  if (!telemetry || !vehicle) return null

  const isEV = vehicle.energy_type === 'ELECTRIC'
  const maxAutonomy = isEV ? vehicle.maximum_autonomy : (vehicle.tank_size / vehicle.average_consumption) * 100
  const autonomyKm = telemetry.autonomy
  const percent = autonomyKm ? ((autonomyKm / maxAutonomy) * 100).toFixed(1) : null
  const icon = isEV ? EvStationIcon : LocalGasStationIcon
  const action = translate(`${INFO_WINDOW_TRANSLATION_KEY}.autonomy.${isEV ? 'recharge' : 'refuel'}`)

  return (
    <FieldRow
      icon={
        <CircularGaugeIcon
          percent={percent}
          thresholds={[
            {
              limit: 10,
              color: '#d32f2f',
              label: { message: 'autonomy.criticalRange', options: { action, value: percent } },
            },
            {
              limit: 40,
              color: '#ed6c02',
              label: { message: 'autonomy.lowRange', options: { action, value: percent } },
            },
            {
              limit: Infinity,
              color: '#1fd92e',
              label: { message: 'autonomy.normalRange', options: { action, value: percent } },
            },
          ]}
          value={percent}
          Icon={icon}
        />
      }
    >
      <UnitField source="autonomy" unit="km" />
    </FieldRow>
  )
}

export default AutonomyField
